import { render, staticRenderFns } from "./OpenDentalDataControl.vue?vue&type=template&id=1df52668"
import script from "./OpenDentalDataControl.vue?vue&type=script&lang=js"
export * from "./OpenDentalDataControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports